import styled, { css } from "styled-components";
import { zIndex } from "../../../settings";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
export var tooltipColor = "secondaryDark";
var arrowHeightSpace = 1;
export var Box = styled.span.withConfig({
  componentId: "sc-1s5mvzd-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;max-width:", ";padding:", ";border-radius:", ";background-color:", ";z-index:", ";"], space(50), space(2), getBorderRadius(theme, "medium"), getColor(theme, tooltipColor), zIndex.ModalOrg + 1);
});
export var Arrow = styled.span.withConfig({
  componentId: "sc-1s5mvzd-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["position:absolute;border:", " solid transparent;border-bottom-color:", ";&::after{content:\"\";position:absolute;top:", ";left:", ";width:", ";height:", ";background:", ";}[data-tooltip-placement*=\"bottom\"] &{top:", ";}[data-tooltip-placement*=\"top\"] &{bottom:", ";}"], space(arrowHeightSpace), getColor(theme, tooltipColor), space(arrowHeightSpace), space(-1 * arrowHeightSpace), space(2 * arrowHeightSpace), space(arrowHeightSpace), getColor(theme, tooltipColor), space(-2 * arrowHeightSpace), space(-2 * arrowHeightSpace));
});